<!-- HomeCredit.vue -->
<template>
  <div class="home-credit"
    :class="[deviceType === 'mobile' ? 'detect_deviece_mobile' : 'detect_deviece_pc']">
    <div class="credit-header">
      <div class="header-title">Best Auto Loan Rates for Bad Credits</div>
      <div class="header-desc">Explore competitive auto loan rates specifically designed for those
        with bad credit.</div>
      <div class="header-line"></div>
    </div>
    <!-- PC端/非mobile端原有结构 -->
    <div v-if="deviceType !== 'mobile'" class="credit-cards">
      <div v-for="(lender, index) in displayLenders" :key="index" class="credit-card">
        <div class="card-header">
          <div class="rating">
            <img src="@/assets/icons/star.svg" alt="Rating" class="star-icon" />
            <span>{{ lender.rating || (lender.rate ? parseFloat(lender.rate).toFixed(1) : '4.0') }}</span>
          </div>
          <div class="lender-name">{{ lender.name || lender.lender }}</div>
        </div>
        <div class="card-content">
          <div class="logo-container">
            <img :src="lender.logoUrl" alt="Lender logo" class="lender-logo" />
          </div>
          <div class="lender-details-container">
            <div class="detail-block">
              <div class="detail-label">APR from</div>
              <div class="detail-value">{{ lender.apr || lender.aprFrom }}</div>
            </div>
            <div class="divider"></div>
            <div class="detail-block">
              <div class="detail-label">Loan term</div>
              <div class="detail-value">{{ lender.term || `${lender.loanTerm } Mos` }}</div>
            </div>
            <div class="divider"></div>
            <div class="detail-block">
              <div class="detail-label">Loan amount</div>
              <div class="detail-value">{{ lender.amount || `$${lender.loanAmount }` }}
              </div>
            </div>
          </div>
        </div>
        <a class="see-details-btn" :href="getLenderDetailsUrl(lender)">
          <span>See Details</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"
            fill="none">
            <path
              d="M9.68066 0C9.83345 8.52298e-05 9.97979 0.0601591 10.0879 0.166707L16 6.00048L10.0879 11.8333C9.97979 11.9398 9.83345 11.9999 9.68066 12C9.52776 12 9.38064 11.9399 9.27246 11.8333L8.45703 11.0287C8.40356 10.976 8.36101 10.9135 8.33203 10.8446C8.30301 10.7756 8.2881 10.7016 8.28809 10.6268C8.28809 10.5521 8.30302 10.4781 8.33203 10.4091C8.36106 10.34 8.40341 10.2768 8.45703 10.224L11.583 7.14045H0.578125C0.424844 7.14045 0.277331 7.08069 0.168945 6.97374C0.0606338 6.8668 0 6.72118 0 6.56998V5.43002C0 5.27877 0.0605622 5.13321 0.168945 5.02626C0.277331 4.91931 0.424844 4.85955 0.578125 4.85955H11.582L8.45703 1.77596C8.34898 1.66922 8.28809 1.52404 8.28809 1.37316C8.28817 1.22248 8.34915 1.07799 8.45703 0.971332L9.27246 0.166707C9.38064 0.0600831 9.52776 0 9.68066 0Z"
              fill="currentColor" />
          </svg>
        </a>
      </div>
    </div>
    <!-- mobile端独立横滑结构 -->
    <div v-else class="credit-cards-mobile-scroll">
      <div class="credit-cards" ref="creditScroll">
        <div v-for="(lender, index) in displayLenders" :key="index" class="credit-card">
          <div class="card-header">
            <div class="rating">
              <img src="@/assets/icons/star.svg" alt="Rating" class="star-icon" />
              <span>{{ lender.rating || (lender.rate ? parseFloat(lender.rate).toFixed(1) : '4.0') }}</span>
            </div>
            <div class="lender-name">{{ lender.name || lender.lender }}</div>
          </div>
          <div class="logo-container">
            <img :src="lender.logoUrl" alt="Lender logo" class="lender-logo" />
          </div>
          <div class="divider"></div>

          <div class="lender-details">
            <div class="detail-item">
              <div class="detail-label">APR from</div>
              <div class="detail-value">{{ lender.apr || lender.aprFrom }}</div>
            </div>
            <div class="divider"></div>
            <div class="detail-item">
              <div class="detail-label">Loan term</div>
              <div class="detail-value">{{ lender.term || `${lender.loanTerm } mos` }}</div>
            </div>
            <div class="divider"></div>
            <div class="detail-item">
              <div class="detail-label">Loan amount</div>
              <div class="detail-value">{{ lender.amount || `$${lender.loanAmount }` }}
              </div>
            </div>
          </div>
          <div class="divider"></div>
          <a class="see-details-btn" :href="getLenderDetailsUrl(lender)">
            <span>See Details</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"
              fill="none">
              <path
                d="M9.68066 0C9.83345 8.52298e-05 9.97979 0.0601591 10.0879 0.166707L16 6.00048L10.0879 11.8333C9.97979 11.9398 9.83345 11.9999 9.68066 12C9.52776 12 9.38064 11.9399 9.27246 11.8333L8.45703 11.0287C8.40356 10.976 8.36101 10.9135 8.33203 10.8446C8.30301 10.7756 8.2881 10.7016 8.28809 10.6268C8.28809 10.5521 8.30302 10.4781 8.33203 10.4091C8.36106 10.34 8.40341 10.2768 8.45703 10.224L11.583 7.14045H0.578125C0.424844 7.14045 0.277331 7.08069 0.168945 6.97374C0.0606338 6.8668 0 6.72118 0 6.56998V5.43002C0 5.27877 0.0605622 5.13321 0.168945 5.02626C0.277331 4.91931 0.424844 4.85955 0.578125 4.85955H11.582L8.45703 1.77596C8.34898 1.66922 8.28809 1.52404 8.28809 1.37316C8.28817 1.22248 8.34915 1.07799 8.45703 0.971332L9.27246 0.166707C9.38064 0.0600831 9.52776 0 9.68066 0Z"
                fill="currentColor" />
            </svg>
          </a>
        </div>
      </div>
    </div>
    <div class="view-all-container">
      <a :href="getPageUrl('/lenders-for-bad-credits')" class="view-all-btn">
        <span>View All Lenders</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"
          fill="none">
          <path
            d="M9.68066 0C9.83345 8.52298e-05 9.97979 0.0601591 10.0879 0.166707L16 6.00048L10.0879 11.8333C9.97979 11.9398 9.83345 11.9999 9.68066 12C9.52776 12 9.38064 11.9399 9.27246 11.8333L8.45703 11.0287C8.40356 10.976 8.36101 10.9135 8.33203 10.8446C8.30301 10.7756 8.2881 10.7016 8.28809 10.6268C8.28809 10.5521 8.30302 10.4781 8.33203 10.4091C8.36106 10.34 8.40341 10.2768 8.45703 10.224L11.583 7.14045H0.578125C0.424844 7.14045 0.277331 7.08069 0.168945 6.97374C0.0606338 6.8668 0 6.72118 0 6.56998V5.43002C0 5.27877 0.0605622 5.13321 0.168945 5.02626C0.277331 4.91931 0.424844 4.85955 0.578125 4.85955H11.582L8.45703 1.77596C8.34898 1.66922 8.28809 1.52404 8.28809 1.37316C8.28817 1.22248 8.34915 1.07799 8.45703 0.971332L9.27246 0.166707C9.38064 0.0600831 9.52776 0 9.68066 0Z"
            fill="white" />
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HomeCredit',
  data () {
    return {
      lenders: []
    }
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'subprimeLendingInstitutions'
    ]),
    displayLenders () {
      // 如果有API返回的数据，优先使用，否则使用默认数据
      return this.subprimeLendingInstitutions && this.subprimeLendingInstitutions.length > 0
        ? this.subprimeLendingInstitutions.slice(0, 5)
        : this.lenders
    }
  },
  methods: {
    getPageUrl (path) {
      if (this.$route.params.channel) {
        return `/${this.$route.params.channel}${path}`;
      }
      return path;
    },
    getLenderDetailsUrl (lender) {
      const lenderName = (lender.name || lender.lender || '').toLowerCase().replace(/\s+/g, '-');
      const id = lender.id || '1'; // Ensure there's a fallback for id
      let path = `/lenders/${lenderName}/${id}`;
      if (this.$route.params.channel) {
        path = `/${this.$route.params.channel}${path}`;
      }
      return path;
    }
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.home-credit {
	padding: rem(60) rem(120);
	display: flex;
	flex-direction: column;

	&.detect_deviece_mobile {
		padding: 0 0 0 rem(16);
	}

	.credit-header {
		margin-bottom: rem(40);
		text-align: center;

		.detect_deviece_mobile & {
			margin-bottom: rem(30);
			padding-right: rem(16);
		}

		.header-title {
			color: #1a4048;
			font-size: rem(36);
			line-height: rem(40);
			font-weight: 800;
			margin-bottom: rem(16);
		}

		.header-desc {
			color: #1a4048;
			font-size: rem(16);
			line-height: rem(24);
			font-weight: 400;
			margin-bottom: rem(16);
		}

		.header-line {
			width: rem(100);
			height: rem(4);
			background-color: var(--theme-primary);
			margin: 0 auto;
		}
	}

	.credit-cards {
		display: flex;
		flex-direction: column;
		gap: rem(20);
	}

	.credit-card {
		background: linear-gradient(90deg, var(--theme-primary-light) 0%, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0) 100%);
		border-radius: rem(24);
		border: rem(1) solid #e5e7eb;
		// transition: border 0.3s ease;
		position: relative;
		overflow: hidden;
		padding: rem(48) rem(36) rem(24) rem(36);

		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: rem(24);

		&:hover {
			border: rem(2) solid #1a4048;

			.see-details-btn {
				background-color: #1a4048;
				color: white;

				svg path {
					stroke: white;
				}
			}
		}

		.detect_deviece_mobile & {
			flex-direction: column;
			width: rem(320);
			padding: rem(48) rem(16) rem(16) rem(16);
			flex-shrink: 0;
			align-items: stretch;
			align-content: stretch;
			gap: rem(16);
		}
	}

	.card-header {
		display: flex;
		flex-direction: row;
		align-items: center;
		position: absolute;
		top: 0;
		left: 0;
	}

	.rating {
		display: flex;
		align-items: center;
		gap: rem(8);
		background: linear-gradient(270deg, rgba(218, 161, 13, 1) 0%, rgba(246, 195, 63, 1) 100%);
		border-radius: rem(24) 0 0 0;
		padding: 0 rem(16);
		height: rem(32);

		.star-icon {
			width: rem(12);
			height: rem(12);
		}
		span {
			color: white;
			font-size: rem(16);
			line-height: rem(16);
			font-weight: 900;
		}
	}

	.lender-name {
		color: #ffffff;
		font-size: rem(14);
		line-height: rem(16);
		font-weight: 800;
		background: #1a4048;
		border-radius: 0 0 rem(16) 0;
		padding: rem(8) rem(16);
		height: rem(32);
	}

	.card-content {
		padding: 0;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.detect_deviece_mobile & {
			flex-direction: column;
			align-items: flex-start;
		}
	}

	.logo-container {
		width: rem(88);
		height: rem(88);
		border-radius: rem(20);
		background-color: white;
		border: rem(2) solid var(--theme-primary-light);
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		margin-right: rem(36);

		.detect_deviece_mobile & {
			width: rem(88);
			height: rem(88);
			aspect-ratio: 1 / 1;
			margin-bottom: 0;
		}
	}

	.lender-logo {
		max-width: 80%;
		max-height: 80%;
		object-fit: contain;
	}

	.divider {
		width: rem(1);
		height: rem(52);
		background-color: #e5e7eb;
		margin: 0;

		.detect_deviece_mobile & {
			width: 100%;
			height: rem(1);
		}
	}

	.lender-details-container {
		display: flex;
		flex-direction: row;
		gap: rem(36);
		align-items: flex-start;
		flex-grow: 1;
	}

	.lender-details {
		display: flex;
		flex-direction: column;
		gap: rem(16);
	}

	.detail-block {
		display: flex;
		flex-direction: column;
		gap: rem(12);
		align-items: flex-start;
		width: rem(170);

		&:last-child {
			width: rem(260);
		}
	}

	.detail-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.detail-label {
		color: #1a4048;
		font-size: rem(14);
		line-height: rem(16);
		font-weight: 400;
	}

	.detail-value {
		color: #1a4048;
		font-size: rem(24);
		line-height: rem(24);
		font-weight: 700;
	}

	.card-footer {
		padding: 0;
		display: flex;
		justify-content: flex-end;
		border-top: none;
		position: static;
	}

	.user-avatar {
		position: absolute;
		right: rem(100);
		top: rem(-24);
		width: rem(48);
		height: rem(48);
		background-color: #4caf50;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		border: rem(2) solid white;
		overflow: hidden;
		z-index: 1;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	.see-details-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: rem(12);
		padding: rem(12) rem(32);
		border-radius: rem(100);
		border: rem(1) solid #1a4048;
		background-color: white;
		color: #1a4048;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 700;
		text-decoration: none;
		transition: all 0.3s ease;
		height: rem(48);

		&:hover {
			background-color: #1a4048;
			color: white;

			svg path {
				stroke: white;
			}
		}

		svg {
			width: rem(16);
			height: rem(12);
		}
		.detect_deviece_mobile & {
			display: flex;
			height: rem(48);
			padding: rem(12) rem(32);
			justify-content: center;
			align-items: center;
			gap: rem(12);
			width: fit-content;
		}
	}

	.view-all-container {
		display: flex;
		justify-content: center;
		margin-top: rem(40);
	}

	.view-all-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: rem(8);
		padding: rem(12) rem(24);
		border-radius: rem(100);
		background-color: var(--theme-primary);
		color: white;
		font-size: rem(16);
		line-height: rem(20);
		font-weight: 700;
		text-decoration: none;
		transition: background-color 0.3s ease;

		&:hover {
			background-color: #00b8d9;
		}

		svg {
			width: rem(16);
			height: rem(16);
		}
	}

	.credit-cards-mobile-scroll {
		overflow: auto;
		display: flex;
		flex-direction: row;
		gap: calc(16 / var(--fontsize-base) * 1rem);
		flex-wrap: nowrap;
		padding: 0;
		-webkit-overflow-scrolling: touch;
		scrollbar-width: none;
		&::-webkit-scrollbar {
			display: none;
		}

		.credit-cards {
			display: flex;
			flex-direction: row;
			gap: rem(16);
			flex-wrap: nowrap;
		}
	}

	// .detect_deviece_mobile {
	// 	.credit-card {
	// 		min-width: rem(320);
	// 		max-width: rem(320);
	// 		flex: 0 0 rem(320);
	// 		border-radius: rem(24);
	// 		padding: rem(48) rem(16) rem(16) rem(16);
	// 		background: linear-gradient(180deg, var(--theme-primary-light) 0%, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0) 100%);
	// 		border: rem(1) solid #e5e7eb;
	// 		box-sizing: border-box;
	// 		display: flex;
	// 		flex-direction: column;
	// 		gap: rem(16);
	// 		position: relative;

	// 		.logo-container {
	// 			width: rem(88);
	// 			height: rem(88);
	// 			border-radius: rem(20);
	// 			background: #ffffff;
	// 			border: rem(2) solid var(--theme-primary-light);
	// 			display: flex;
	// 			align-items: center;
	// 			justify-content: center;
	// 			margin: 0;
	// 		}

	// 		.lender-details {
	// 			display: flex;
	// 			flex-direction: column;
	// 			gap: rem(16);
	// 			align-items: flex-start;
	// 			justify-content: flex-start;
	// 			align-self: stretch;
	// 		}

	// 		.detail-item {
	// 			display: flex;
	// 			flex-direction: row;
	// 			align-items: center;
	// 			justify-content: space-between;
	// 			align-self: stretch;
	// 			flex-shrink: 0;
	// 		}

	// 		.detail-label {
	// 			color: #0e192c;
	// 			font-size: rem(14);
	// 			line-height: rem(16);
	// 			font-weight: 400;
	// 		}

	// 		.detail-value {
	// 			color: #0e192c;
	// 			font-size: rem(20);
	// 			line-height: rem(20);
	// 			font-weight: 700;
	// 		}

	// 		.divider {
	// 			background: #e5e7eb;
	// 			align-self: stretch;
	// 			height: rem(1);
	// 			margin: rem(10) 0;
	// 		}

	// 		.see-details-btn {
	// 			background: #ffffff;
	// 			border-radius: rem(100);
	// 			border: rem(1) solid #0e192c;
	// 			padding: rem(12) rem(32);
	// 			display: flex;
	// 			flex-direction: row;
	// 			gap: rem(12);
	// 			align-items: center;
	// 			justify-content: center;
	// 			height: rem(48);
	// 			margin-top: auto;

	// 			span {
	// 				color: #0e192c;
	// 				font-size: rem(16);
	// 				line-height: rem(16);
	// 				font-weight: 700;
	// 			}
	// 		}
	// 	}
	// }
}
</style> 